import { Link } from 'react-router-dom'

interface CardProps {
  title: string
  description: string
  imageUrl?: string
  linkTo?: string
  children?: React.ReactNode
}

const Card = ({ title, description, imageUrl, linkTo, children }: CardProps) => {
  const inner = (
    <>
      {imageUrl && <img src={imageUrl} alt={title} />}
      <div className="card-body">
        <h3>{title}</h3>
        <p>{description}</p>
        {children}
      </div>
    </>
  )

  return linkTo ? (
    <Link to={linkTo} className="card clickable">
      {inner}
    </Link>
  ) : (
    <div className="card">
      {inner}
    </div>
  )
}

export default Card
